import styled from "@emotion/styled";
import { Form } from "antd";

const Styles = styled(Form.Item)`
  .btn-round {
    border-radius: 100px !important;
  }
`;
export default Styles;
